import { mapGetters, mapActions } from 'vuex'
import { editorManuscript, editorDecision, editor } from '@/api/editor'
import { minvitedReviewer, reviewerWait } from '@/api/reviewer'
import journal from '@/api/journal'
import mfile from '@/api/mfile'
import apc from '@/api/apc'
import { macademic, macademicSend } from '@/api/macademic'
import meditor from '@/api/meditor'
import person from '@/api/person'
import operation from '@/api/operation'
import publisher from '@/api/publisher'
import manuscript from '@/api/manuscript'
import CreatePNG from '@/components/createPNG.dialog.vue'

import {
  ARTICLE_STATUS,
  REVIEWER_STATUS,
  DECISION,
  DECISION_STATUS
} from '@/utils/dict'
import help from '@/utils/help'
import { getUploadConfig } from '@/utils/upload'

import DetailActions from '../dialog/detail-actions'
import AssignEditorDialog from '../dialog/assign-editor.dialog'
import ChangeDueDate from '../dialog/change-due-data.dialog'
import ManuscriptVersions from '../dialog/manuscript-versions.dialog'
import UpdateFiles from '../dialog/update-files.dialog'
import AddReviewer from '../dialog/add-reviewer.dialog'
import SearchReviewer from '../dialog/search-reviewer.dialog'
import AuthorQuestionnaire from '../dialog/author-questionnaire.dialog'
import ReviewResult from '../dialog/review-result.dialog'
import RejectReason from '../dialog/reject-reason.dialog'
import ReviewSelect from '../dialog/review-select.dialog'
import EditorDecision from '../dialog/editor-decision.dialog'
import SendEmail from '../dialog/send-email.dialog'
import endConfirm from '../dialog/end-confirm.dialog'
import hindexConfirm from '../dialog/hindex-confirm.dialog'
import reviewReport from '../dialog/review-report'
import Transfer from '../dialog/transfer.dialog'
import reviewLimit from '../dialog/review-limit-day'
import importReview from '../dialog/import-review'
import EditDate from '../dialog/edit-date.dialog'

import SelectEditorDialog from '../dialog/select-editor.dialog'
import AddCheckedDialog from '../dialog/add-checked.dialog'
import moment from 'moment'

const columns = [
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'email'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 140,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Review Status',
    width: 150,
    dataIndex: 'status',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Recommendation',
    width: 180,
    dataIndex: 'decisionStatus',
    slot: 'decisionStatus'
  },
  {
    title: '',
    enTitle: 'Invited Date',
    width: 120,
    dataIndex: 'invitedTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Reminder Date',
    width: 200,
    dataIndex: 'remindList',
    slot: 'remind'
  },
  {
    title: '',
    enTitle: 'Agreed Date',
    width: 120,
    dataIndex: 'agreedTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Review Due Date',
    width: 150,
    dataIndex: 'reviewDueTime',
    slot: 'reviewDueTime'
  },
  {
    title: '',
    enTitle: 'Completed Date',
    width: 150,
    dataIndex: 'completedTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Suggest Own References',
    width: 150,
    dataIndex: 'suggestReferNum',
    slot: 'suggest'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 100,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
const columnsEditors = [
  {
    title: '',
    enTitle: 'Name',
    width: 120,
    dataIndex: 'editor',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Roles',
    width: 200,
    dataIndex: 'rolelist',
    slot: 'rolelist'
  },
  {
    title: '',
    enTitle: 'Assigned Date ',
    width: 120,
    dataIndex: 'assignedTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Completed Date',
    width: 120,
    dataIndex: 'completedTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Elapsed Days',
    width: 120,
    dataIndex: 'id',
    slot: 'elapsed'
  },
  {
    title: '',
    enTitle: 'Recommendation',
    width: 150,
    dataIndex: 'decisionStatus',
    slot: 'decisionStatus'
  }
]
export default {
  components: {
    DetailActions,
    AssignEditorDialog,
    ChangeDueDate,
    ManuscriptVersions,
    UpdateFiles,
    AddReviewer,
    SearchReviewer,
    AuthorQuestionnaire,
    ReviewResult,
    RejectReason,
    ReviewSelect,
    EditorDecision,
    SendEmail,
    endConfirm,
    hindexConfirm,
    reviewReport,
    Transfer,
    reviewLimit,
    importReview,

    SelectEditorDialog,
    CreatePNG,
    AddCheckedDialog,
    EditDate
  },
  data() {
    return {
      columns,
      columnsEditors,
      ARTICLE_STATUS,
      REVIEWER_STATUS,
      DECISION,
      DECISION_STATUS,
      articleDetail: {
        signList: [],
        articleDetail: false,
        status: '',
        mauthorList: [],
        autoReplyMeditor: {
          authorNotes: '',
          authorReply: ''
        }
      },

      showAssignEditor: false,
      showChangeDueDate: false,
      showManuscriptVersions: false,
      showUpdateFiles: false,
      showAddReviewer: false,
      showSearchReviewer: false,
      showAuthorQuestionnaire: false,
      showReviewResult: false,
      showRejectReason: false,
      showReviewSelect: false,
      showEditorDecision: false,
      showSendEmail: false,
      endConfirm: false,
      hindexDialog: false,
      showReviewReport: false,
      showTransfer: false,
      showReviewLimit: false,
      showAuthor: false,
      showAuthorRevision: true,
      showAuthorResponseEditor: true, // Author Response to Editor

      showAuthorNotes: {
        PRE_CHECK: false,
        FIRST_CHECK: false,
        FINAL_CHECK: false
      },

      sendFiles: [],

      showAbstract: false,
      reviewerKeyword: '',
      dueDays: 0, // Due Days
      tempReviewer: [],
      journalList: [],
      articleReviewer: [],
      articleEditor: [],
      reviewerCountObj: {},
      inputData: {},
      // 当前数据
      emailData: {},
      emailType: '',
      emailIndex: '',
      showEmailSendData: {},
      params: {
        sign: 2
      },
      reviewerPrasms: {
        status: ''
      },

      isEditApc: false,
      apc: {
        apc: '',
        discount: '',
        discountFee: '',
        total: '',
        satisfied: false
      },
      apcRules: {},
      apcData: {},

      macademic: {
        PRE_CHECK: {},
        FIRST_CHECK: {},
        FINAL_CHECK: {}
      },
      decisionType: '',
      showSelectEditor: false,
      mac: false,

      peerViewFlag: false,

      decisionList: [],
      decision: {
        decisionStatus: '',
        reviseDueTime: ''
      },
      loading: {
        PRE_CHECK: false,
        review: false,
        FIRST_CHECK: false,
        FINAL_CHECK: false
      },

      showAEC: {
        FIRST_CHECK: true,
        FINAL_CHECK: true
      },

      editAEC: {
        FIRST_CHECK: false,
        FINAL_CHECK: false
      },

      authorReply: {
        macademicId: '',
        authorReply: '',
        authorReplyFileList: [],
        loading: false
      },

      showReviewTimeInfo: {},

      event: '',
      ReviewHistoryScrollTop: 0,
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getArticleReviewer,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      download: help.download,

      showFiles: true,
      showAPC: true,
      showPreCheck: true,
      showPeerReview: true,
      showFirstCheck: true,
      showFinalCheck: true,
      showDecisionToAuthor: true,
      showSubmittedByEditors: true,
      showImportReview: false,

      pdfType: 'rc-c',
      isVisablePDF: false,
      showCheck: false, // 检查备注弹框
      declinedFlag: false,
      auReviseData: {},
      showEditDate: false,
      PRE_remind: [], // 预审 初审 终审 提醒时间
      FIRST_remind: [],
      FINAL_remind: [],

      refuseList: [], // 拒绝理由列表
      selectReason: '', //
      isOpenItem: [], //控制每级面板的打开与折叠
      isSelectAll: [], //控制每级面板的选中状态
      othersReason: '',
      peerViewHistory: false,
      othersId: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      title: 'getTitle',
      manuscriptType: 'getManuscriptType',
      publisherId: 'getPublisherId',
      publisherInfo: 'getPublisherInfo',
      user: 'getUser',
      reviewRefuse: 'getReviewRefuse'
    })
  },
  async mounted() {
    this.id = this.$route.params.id

    let publisherId = 'imr'
    this.params.sign = this.$route.query.sign

    setTimeout(() => {
      const hash = this.$route.hash ? this.$route.hash.split('#')[1] : ''
      if (hash) {
        const el = this.$refs[hash]
        this.ReviewHistoryScrollTop = document.documentElement.scrollTop = document.body.scrollTop =
          el.offsetTop - 100
      }
    }, 500)
    await this.getQuery()
    await this.changeVersion(this.params.sign)
    this.$refs['detail-action'].manuscriptNote('remark')
    this.getJournalList()
    this.getAPCRules()
    this.getAPC(this.id)
    this.getDecison()
    this.getPublisherInfo(publisherId)
    await this.getRefuseList()
    this.initData()
    help.closeAutocomplete()
  },
  methods: {
    ...mapActions(['updatePublisherId', 'updatePublisherInfo']),
    async getPublisherInfo(publisherId) {
      this.updatePublisherInfo(await publisher.query(publisherId))
      this.updatePublisherId(this.publisherInfo.id)
    },
    async getQuery() {
      this.articleDetail = await editorManuscript.query(this.id, {
        sign: this.params.sign
      })
      // mock
      // this.articleDetail = articleDetail
      if (
        ['PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(
          this.articleDetail.status
        )
      ) {
        this.reviewerPrasms.status = 'COMPLETED'
      }
      this.declinedFlag =
        this.articleDetail.mauthorList &&
        this.articleDetail.mauthorList.some(item => {
          return item.status === 'DECLINED'
        })
      this.params.sign = this.articleDetail.sign
      this.dueDays = this.articleDetail.journal.reviewDeadline
      const dueDays = localStorage.getItem('dueDays')
      const data = JSON.parse(JSON.stringify(this.articleDetail))
      this.peerViewFlag = data.peerConfirmed ? data.peerConfirmed : false
      if (dueDays) {
        this.dueDays = dueDays
      }
      this.getReviewerCount()
      this.getReviewerWait()
      this.getArticleEditor()
      this.getMacademic()
      this.getAuthorRevise()
    },
    async changeVersion(val) {
      if (val && this.params.sign !== val) {
        this.$router.push('?sign=' + val)
      }
      this.params.sign = val
      const currentVersion = this.articleDetail.signList.sort((a, b) => {
        return b - a
      })[0]
      if (val != currentVersion) {
        this.peerViewHistory = true
      } else {
        this.peerViewHistory = false
      }

      await this.getQuery()
    },
    changeEditor() {
      this.inputData = this.articleDetail
      this.showAssignEditor = true
    },
    attachmentVersion() {
      this.inputData = this.articleDetail
      this.showManuscriptVersions = true
    },
    updateAttachment() {
      this.inputData = this.articleDetail
      this.showUpdateFiles = true
    },
    viewMoreAuthor() {
      this.$router.push(
        `/editorial-office/manuscripts/details/other-author/${this.articleDetail.id}?sign=${this.articleDetail.sign}`
      )
    },
    async viewSpecialIssue() {
      const { journal, special } = this.articleDetail
      let url = `/journal/${journal.name}/special_issues/${special.code}`
      const { host } = window.location
      if (
        host.includes('192.168.5') ||
        host.includes('192.168.4.34') ||
        host.includes('102.168.4.21') ||
        host.includes('localhost')
      ) {
        url = 'http://192.168.5.18:3020' + url
      } else if (
        host.includes('192.168.4.23') ||
        host.includes('imrpress.tech:9100')
      ) {
        url = 'http://www.imrpress.tech' + url
      } else if (host.includes('imrpress.tech:8100')) {
        url = 'http://www.imrpress.tech:9000' + url
      } else if (host.includes('propub.com')) {
        url = 'https://www.imrpress.com' + url
      } else {
        url = 'http://192.168.5.18:3020' + url
      }
      window.open(url)
    },
    viewAuthorQuestionaire() {
      this.inputData = this.articleDetail
      this.showAuthorQuestionnaire = true
    },
    async handleUpload(files, originType, aec) {
      const file = files[0]
      const types = ['pdf', 'zip']
      const type = file.name.split('.')
      if (!types.includes(type[type.length - 1]) && aec !== 'AEC') {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }

      const MS = 30
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }

      const path = `publisher/${this.publisherId}/manuscript/${
        this.articleDetail.id
      }/${originType}-document/${help.guid()}`

      if (aec === 'AEC') {
        this.authorReply.loading = true
      } else {
        this.loading[originType] = true
      }

      const url = await getUploadConfig(file, path)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      if (['PRE_CHECK', 'FIRST_CHECK', 'FINAL_CHECK'].includes(originType)) {
        if (aec === 'AEC') {
          this.authorReply.authorReplyFileList.push({
            name: file.name,
            size: file.size,
            path: url
          })
        } else {
          await macademic.mfile({
            name: file.name,
            size: file.size,
            path: url,
            manuscriptId: this.articleDetail.id,
            sign: this.articleDetail.sign,
            originType
          })
          this.getMacademic(originType)
          this.getQuery()
        }
      } else {
        await mfile.reviewer({
          name: file.name,
          size: file.size,
          path: url,
          manuscriptId: this.articleDetail.id,
          sign: this.articleDetail.sign
        })
        this.getQuery()
      }
      this.$message.success({
        title: 'Success',
        content: 'File Uploaded Successfully'
      })

      if (aec === 'AEC') {
        this.authorReply.loading = false
      } else {
        this.loading[originType] = false
      }
    },
    openReviewResult(val, mac) {
      this.inputData = val
      this.showReviewResult = true
      this.mac = mac
    },

    // 生成证书
    async createCanvans(val, type) {
      const res = await manuscript.certificate(val.id)
      this.inputData = res
      this.pdfType = type
      this.isVisablePDF = true
    },

    // 查看详情
    detail(val) {
      help.openWindow(
        `/editorial-office/manuscripts/details/reviews-report/${val.id}?sign=${val.sign}`
      )
    },

    openRejectReason(val) {
      this.inputData = val
      this.showRejectReason = true
      // this.$router.push(`/editorial-office/manuscripts/details/refuse/${val.id}`)
    },

    onDueDaysChange() {
      localStorage.setItem('dueDays', this.dueDays)
    },

    searchAndAddReviewers() {
      if (
        !this.articleDetail.reviewerDocumentList ||
        !this.articleDetail.reviewerDocumentList.length
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please upload the review document first！'
        })
        return
      }
      this.inputData = {
        journalId: this.articleDetail.journalId,
        selectdList: this.tempReviewer,
        id: this.articleDetail.id,
        sign: this.articleDetail.sign
      }
      this.showSearchReviewer = true
    },

    async addReviewerList(val) {
      // this.tempReviewer = val
      const tempReviewerIds = this.tempReviewer.map(item => item.personId)
      const selectIds = val.map(item => item.personId)
      const arr = tempReviewerIds.filter(item => {
        return selectIds.indexOf(item) == -1
      })
      await reviewerWait.add({
        manuscriptId: this.articleDetail.id,
        personIdList: val.map(item => {
          return item.personId
        }),
        deletePersonIdList: arr
      })
      this.getReviewerWait()
      this.showSearchReviewer = false
    },

    async searchReviewers(val) {
      if (!val) {
        return
      }
      if (
        !this.articleDetail.reviewerDocumentList ||
        !this.articleDetail.reviewerDocumentList.length
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please upload the review document first！'
        })
        return
      }
      this.showAddReviewer = false
      this.showReviewSelect = false
      try {
        const res = await minvitedReviewer.like({
          manuscriptId: this.articleDetail.id,
          sign: this.articleDetail.sign,
          keyword: val
        })
        if (res && res.length) {
          if (res.length > 1) {
            this.inputData = {
              reviewSelect: res
            }
            this.showReviewSelect = true
          } else {
            let flag = false
            flag =
              res[0].roleList &&
              res[0].roleList.some(item => {
                return item.type === 'REVIEWER'
              })
            if (flag) {
              this.addTempReviewer(res[0])
            } else {
              this.showAddReviewer = true
              const {
                email,
                firstName,
                lastName,
                hindex,
                hindexUrl,
                icon,
                affiliation,
                keyword
              } = res[0]
              this.inputData = {
                email,
                firstName,
                lastName,
                hindex,
                hindexUrl,
                icon,
                affiliations: affiliation ? affiliation.split(';') : [''],
                keywords: keyword ? keyword.split(';') : [],
                journalIdList: [this.articleDetail.journalId]
              }
            }
          }
          this.reviewerKeyword = ''
        } else {
          this.showAddReviewer = true
          this.inputData = {
            journalId: this.articleDetail.journalId,
            journalIdList: [this.articleDetail.journalId],
            email: val
          }
        }
      } catch (error) {
        this.reviewerKeyword = ''
      }
    },

    async importReviewer() {
      this.showImportReview = true
      this.inputData = this.articleDetail
    },

    async addTempReviewer(val) {
      await reviewerWait.add({
        manuscriptId: this.articleDetail.id,
        personIdList: [val.personId]
      })
      this.getReviewerWait()
      // const flag = this.tempReviewer.some(item => {
      //   if (item.id === val.id) {
      //     this.$message.error({
      //       title: 'Error',
      //       content: 'This reviewer already exists in the list below'
      //     })
      //     return true
      //   }
      // })
      // if (flag) {
      //   return
      // }
      // this.tempReviewer.unshift(val)
    },

    async getReviewerWait() {
      if (this.articleDetail.signList[0] !== this.articleDetail.sign) {
        this.tempReviewer = []
        return
      }
      this.tempReviewer = await reviewerWait.get({
        manuscriptId: this.articleDetail.id
      })
    },

    async getAuthorRevise() {
      const res = await editorDecision.getAuthorRevise({
        sign: this.articleDetail.sign,
        manuscriptId: this.articleDetail.id
      })
      this.auReviseData = res
    },
    async editReviseDate() {
      this.inputData = Object.assign(this.auReviseData, {
        sign: this.articleDetail.sign,
        id: this.articleDetail.id
      })
      this.showEditDate = true
    },
    confirmReviseDate() {
      this.showEditDate = false
      this.getAuthorRevise()
    },
    async getReviewerCount(page = 1) {
      const res = await minvitedReviewer.count({
        manuscriptId: this.articleDetail.id,
        sign: this.articleDetail.sign
      })

      let all = 0
      for (let key in res) {
        all += res[key]
      }

      this.reviewerCountObj = Object.assign({ all }, res)
      this.getArticleReviewer(page)
    },
    reviewHistory() {
      this.$router.push(
        '/editorial-office/manuscripts/details/review-history/' +
          this.articleDetail.id
      )
    },
    changeStatus(val) {
      this.reviewerPrasms.status = val
      this.getArticleReviewer()
    },
    async getArticleReviewer(page = 1) {
      const { list, pageIndex, pageSize, total } = await minvitedReviewer.get({
        manuscriptId: this.articleDetail.id,
        sign: this.articleDetail.sign,
        pageIndex: page,
        status:
          this.reviewerPrasms.status === 'all'
            ? ''
            : this.reviewerPrasms.status,
        pageSize: this.pagination.size
      })
      this.articleReviewer = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },

    async removeReviewer(val) {
      await minvitedReviewer.remove(val.id)
      this.$message.success({
        title: 'Success',
        content: 'Remove this Reviewer Successfully'
      })
      this.getReviewerCount()
      this.sendEmail(val, 'CANCEL_REVIEW_INVITATION')
    },

    async getArticleEditor() {
      this.articleEditor = await editorDecision.history(this.articleDetail.id, {
        sign: this.articleDetail.sign
      })
    },

    changeDueDate(val) {
      this.inputData = val
      this.showChangeDueDate = true
    },

    async delReviewerDoc(val, type) {
      if (!type) {
        await mfile.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
        this.getQuery()
      } else {
        await macademic.mfileDel(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
        this.getMacademic(type)
      }
    },

    confirm() {
      this.showChangeDueDate = false
      this.showAssignEditor = false

      this.showSelectEditor = false
      this.endConfirm = false
      this.showTransfer = false
      this.showImportReview = false
      this.showCheck = false
      this.getQuery()
    },
    // confirmEnd() {
    //   this.endConfirm = false
    //   this.getQuery()
    // },
    cancel() {
      this.showChangeDueDate = false
      this.showAssignEditor = false
      this.showManuscriptVersions = false
      this.showUpdateFiles = false
      this.showAddReviewer = false
      this.showSearchReviewer = false
      this.showAuthorQuestionnaire = false
      this.showReviewResult = false
      this.showRejectReason = false
      this.showReviewSelect = false
      this.showEditorDecision = false
      this.showSendEmail = false

      this.showSelectEditor = false
      this.endConfirm = false
      this.hindexDialog = false
      this.showReviewReport = false
      this.showTransfer = false
      this.showReviewLimit = false
      this.showImportReview = false

      this.isVisablePDF = false
      this.showCheck = false
      this.showEditDate = false
      this.$refs['detail-action'].startScroll()
    },

    copyUnsub(val) {
      help.copyToBlock(val)
      this.$message.success({
        title: 'Success',
        content: 'The E-mail has been copied to the clipboard!'
      })
    },

    // 获取journalist列表
    async getJournalList() {
      this.journalList = await journal.getAll({
        released: true
      })
    },

    async delReviewer(val) {
      // this.tempReviewer.splice(index, 1)
      await reviewerWait.del(val.id)
      this.getReviewerWait()
    },

    async overReviewTime(val) {
      let params = {
        invitedTimeStart: this.$moment().subtract(
          this.publisherInfo.reviewLimitDay,
          'days'
        ),
        invitedTimeEnd: this.$moment()
      }
      const data = await person.rmanuscript(val.personId, params)
      this.showReviewTimeInfo = data.length > 3 ? data.slice(0, 3) : data
    },

    async inviteReviewer(val, index) {
      if (
        !this.articleDetail.reviewerDocumentList ||
        !this.articleDetail.reviewerDocumentList.length
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please upload the review document first！'
        })
        return
      }
      this.inputData = val
      this.inputData.__index = index

      if (!val.hindex) {
        this.hindexDialog = true
        return
      }
      if (
        val.lastMinvitedTime &&
        this.$moment().diff(this.$moment(val.lastMinvitedTime), 'days') <
          this.publisherInfo.reviewLimitDay
      ) {
        this.showReviewLimit = true
        return
      }
      if (val.affed) {
        this.$confirm({
          title: 'Notice',
          content:
            'The reviewer and the author belong to the same Affiliation. Are you sure you want to send the invitation?',
          type: 'danger',
          icon: 'iconDetails'
        }).then(async () => {
          this.confirmInvitateReview(val, index)
        })
        return
      }
      this.confirmInvitateReview(val, index)
    },
    // 确认邀请
    async confirmInvitateReview(val, index) {
      await minvitedReviewer.confirm({
        personId: val.personId,
        manuscriptId: this.articleDetail.id,
        sign: this.articleDetail.sign,
        reviewDueDay: this.dueDays,
        reviewLimitDay:
          val.lastMinvitedTime &&
          this.$moment().diff(this.$moment(val.lastMinvitedTime), 'days') <
            this.publisherInfo.reviewLimitDay
            ? this.publisherInfo.reviewLimitDay
            : ''
      })
      this.$message.success({
        title: 'Success',
        content: 'Invite this Reviewer successfully'
      })
      this.showReviewLimit = false
      this.tempReviewer.splice(index, 1)
      // this.getReviewerCount()
      this.getQuery()
    },
    // 查看决策
    openEditorDecision(val) {
      this.showEditorDecision = true
      this.inputData = val
    },
    // 调用
    async send() {
      // if (this.emailType === 'confirmInvite') {
      //   this.inviteReviewer(this.emailData, this.emailIndex)
      // }
      if (this.emailType === 'backToAuthor') {
        this.$refs['detail-action'].backToAuthorCall()
      }
      if (this.emailType === 'widthdraw') {
        this.$refs['detail-action'].widthdrawCall()
      }
      if (this.emailType === 'submit_to_author') {
        await editorDecision.author({
          id: this.articleDetail.id,
          sign: this.articleDetail.sign,
          meditor: Object.assign(this.decision, {
            reason: this.othersReason,
            reasonId: this.selectReason
          })
        })

        this.getQuery()
        this.$message.success({
          title: 'Success',
          content: 'Make decision successfully'
        })
      }
      if (
        this.emailType === 'pre_check_ack' ||
        this.emailType === 'first_check_ack' ||
        this.emailType === 'final_check_ack'
      ) {
        let id = this.emailData.macademicId || this.emailData.id
        await macademic.acked(id)
        this.getMacademic()
      }
      if (this.emailType === 'editor_submit_apc') {
        await apc.add(this.apc)
        this.getQuery()
        this.getAPC(this.id)
        this.isEditApc = false
      }
      if (
        this.emailType === 'PRE_CHECK' ||
        this.emailType === 'FIRST_CHECK' ||
        this.emailType === 'FINAL_CHECK'
      ) {
        await macademic.cancelInvite(this.articleDetail.id, this.emailType, {
          sign: this.articleDetail.sign
        })
        this.getMacademic(this.emailType)
      }
      if (this.emailType === 'change_review_due_date') {
        await minvitedReviewer.time(this.emailData.id, {
          reviewDueTime: this.emailData.reviewDueTime,
          version: this.emailData.version,
          autoSend: this.emailData.autoSend
        })
        this.$message.success({
          title: 'Success',
          content: `This Review Due Date has been saved!`
        })
        this.changeVersion()
      }
      if (this.emailType === 'cancel_review_invitation') {
        await minvitedReviewer.remove(this.emailData.id)
        this.$message.success({
          title: 'Success',
          content: 'Remove this Reviewer Successfully'
        })
        this.getReviewerCount()
      }
      if (this.emailType === 'remind') {
        await minvitedReviewer.remind(this.emailData.id)
        this.getReviewerCount(this.pagination.current)
      }
      if (
        this.emailType === 'INVITE_PRE_CHECK' ||
        this.emailType === 'INVITE_FIRST_CHECK' ||
        this.emailType === 'INVITE_FINAL_CHECK' ||
        this.emailType === 'GE_INVITE_PRE_CHECK' ||
        this.emailType === 'GE_INVITE_FIRST_DECISION' ||
        this.emailType === 'GE_INVITE_FINAL_DECISION'
      ) {
        await macademicSend.edit(
          this.showEmailSendData.id || this.emailData.macademicId
        )
        this.getQuery()
      }
      if (
        [
          'PRE_CHECK_REMIND',
          'FIRST_DECISION_REMIND',
          'FINAL_DECISION_REMIND'
        ].includes(this.emailType)
      ) {
        let id = this.emailData.macademicId
        await macademic.remind(id)
        this.getMacademic()
      }
      if (this.emailType === 'REMIND_AUTHOR_REVISE') {
        await editorDecision.setAuthorRevise(this.articleDetail.id, {
          sign: this.articleDetail.sign
        })
        this.getAuthorRevise()
      }
      this.cancel()
    },
    // 发送邮件
    async sendEmail(val, event, type, index) {
      this.emailType = type
      this.emailData = val
      this.emailIndex = index
      // if (this.emailType === 'confirmInvite') {
      //   event =
      //     val.historyReviewerList && val.historyReviewerList.length
      //       ? 'INVITE_REVIEWER_FOR_SECOND_ROUND_REVIEW'
      //       : 'INVITE_REVIEWER_FOR_PRELIMINARY_REVIEW'
      // }
      this.sendFiles = []
      const data = {
        manuscriptId: this.articleDetail.id,
        sign: this.articleDetail.sign,
        journalId: this.articleDetail.journalId
      }
      const { id, personId, email } = val
      let url = ''
      switch (event) {
        case 'COMMUNCIATING_WITH_AUTHOR':
          this.inputData = Object.assign(
            {
              authorPersonId: personId,
              coAuthorId: id,
              email
            },
            data
          )
          break
        // case 'INVITE_REVIEWER_FOR_PRELIMINARY_REVIEW':
        // case 'INVITE_REVIEWER_FOR_SECOND_ROUND_REVIEW':
        //   this.inputData = Object.assign(
        //     {
        //       reviewerPersonId: personId,
        //       minvitedReviewerId: id,
        //       email
        //     },
        //     data
        //   )
        //   this.sendFiles = this.articleDetail.reviewerDocumentList
        //   break
        case 'REVIEW_TIME_OUT_REMINDER':
        case 'CHANGE_REVIEW_DUE_DATE':
        case 'CANCEL_REVIEW_INVITATION':
          this.inputData = Object.assign(
            {
              reviewerPersonId: personId,
              minvitedReviewerId: id,
              mreviewerReviseDueTime: val.reviewDueTime,
              email
            },
            data
          )
          break
        case 'BACK_TO_AUTHOR':
        case 'MODIFIED_THE_REVISION_TIME':
        case 'WITHDRAW':
        case 'ACCEPT_MANUSCRIPT':
        case 'MINOR_REVISION_FOR_MANUSCRIPT':
        case 'MAJOR_REVISION_FOR_MANUSCRIPT':
        case 'REJECT_MANUSCRIPT':
          this.inputData = Object.assign(
            {
              editorId: val.editor && val.editor.id,
              authorPersonId: val.submitter && val.submitter.id,
              email: val.submitter && val.submitter.email,
              reviseDueTime:
                (this.decision && this.decision.reviseDueTime) || ''
            },
            data
          )
          break
        case 'REMIND_AUTHOR_REVISE':
        case 'INVITE_PRE_CHECK':
        case 'INVITE_FIRST_CHECK':
        case 'INVITE_FINAL_CHECK':
        case 'GE_INVITE_PRE_CHECK':
        case 'GE_INVITE_FIRST_DECISION':
        case 'GE_INVITE_FINAL_DECISION':
          this.inputData = Object.assign(
            {
              macademicId: this.showEmailSendData.id || val.macademicId,
              journalId: this.articleDetail.journalId,
              sign: val.sign,
              manuscriptId: this.articleDetail.manuscriptId,
              editorPersonId:
                this.showEmailSendData.assignedId || val.assignedId
            },
            data
          )
          break
        case 'PRE_CHECK_ACK':
        case 'FIRST_CHECK_ACK':
        case 'FINAL_CHECK_ACK':
        case 'PRE_CANCEL_INVITE':
        case 'FIRST_CANCEL_INVITE':
        case 'FINAL_CANCEL_INVITE':
        case 'PRE_CHECK_REMIND':
        case 'FIRST_CHECK_REMIND':
        case 'FINAL_CHECK_REMIND':
          this.inputData = Object.assign(
            {
              macademicId: val.macademicId || val.id,
              journalId: this.articleDetail.journalId,
              sign: val.sign,
              manuscriptId: this.articleDetail.manuscriptId
            },
            data
          )
          break
        case 'GE_PRE_CHECK_ACK':
        case 'GE_FIRST_DECISION_ACK':
        case 'GE_FINAL_DECISION_ACK':
        case 'GE_PRE_CHECK_CANCEL':
        case 'GE_FIRST_DECISION_CANCEL':
        case 'GE_FINAL_DECISION_CANCEL':
        case 'GE_PRE_CHECK_REMIND':
        case 'GE_FIRST_DECISION_REMIND':
        case 'GE_FINAL_DECISION_REMIND':
          this.inputData = Object.assign(
            {
              macademicId: val.macademicId || val.id,
              journalId: this.articleDetail.journalId,
              sign: val.sign,
              manuscriptId: this.articleDetail.manuscriptId,
              specialId: this.articleDetail.specialId
            },
            data
          )
          break
        case 'EDITOR_SUBMIT_APC':
          this.inputData = Object.assign(
            {
              journalId: this.articleDetail.journalId,
              sign: val.sign,
              manuscriptId: this.articleDetail.manuscriptId,
              apcDiscount: this.apc.discount,
              apcDiscountFee: this.apc.discountFee,
              apcPrice: this.apc.price,
              apcTotal: this.apc.total
            },
            data
          )
          break
        case 'SEND_APC_INVOICE_TO_AUTHOR':
          this.inputData = Object.assign(
            {
              manuscriptId: val.id,
              sign: val.sign,
              journalId: val.journalId,
              editorId: val.editor && val.editor.id,
              authorPersonId: val.submitter && val.submitter.id,
              email: val.submitter && val.submitter.email
            },
            data
          )
          url = await getUploadConfig(
            this.emailData.__file,
            `${this.publisherId}/journal/${
              this.inputData.journalId
            }/invoice/${help.guid()}`
          )
          this.sendFiles.push({
            name: this.emailData.__file.name + '.pdf',
            size: this.emailData.__file.size,
            path: url
          })
          this.isVisablePDF = false
          break
      }
      this.event = event
      this.showSendEmail = true
      this.$refs['detail-action'].removeScroll()
    },

    // changeAPC() {
    //   if (!this.apc.price) {
    //     this.apc.total = 0
    //   } else {
    //     this.apc.total = +(
    //       this.apc.price *
    //       (1 - (this.apc.discount || 0) * 0.01)
    //     ).toFixed(2)
    //   }
    // },

    editApc() {
      this.isEditApc = true
    },
    cancelApc() {
      this.isEditApc = false
      this.apc = JSON.parse(JSON.stringify(this.apcData))
    },

    async submitAPC() {
      if (this.articleDetail.status === 'SUBMITTED') {
        this.$message.error({
          title: 'Error',
          content: 'Please assign editor first.'
        })
        return
      }
      // await apc.add(this.apc)
      // this.getQuery()
      const flag = this.$refs['apc-confirm-form'].validate()
      if (!flag) {
        return
      }
      if (!this.apc.id) {
        this.sendEmail(this.macademic, 'EDITOR_SUBMIT_APC', 'editor_submit_apc')
      } else {
        await apc.edit(this.apc.id, this.apc)
        let detail = `【Manuscript No.:】: ${this.articleDetail.code};<br/>`
        const keys = {
          price: `【Journal APC ($)】: Change from 【${this.apcData.price}】 to 【${this.apc.price}】;`,
          discount: `【Discount (%)】: Change from  【${this.apcData.discount}】 to 【${this.apc.discount}】;`,
          discountFee: `【Discounted Fee ($)】: Change from  【${this.apcData.discountFee}】 to 【${this.apc.discountFee}】;`,
          total: `【Total ($)】: Change from  【${this.apcData.total}】 to 【${this.apc.total}】;`
        }
        Object.keys(keys).forEach(key => {
          if (
            JSON.stringify(this.apcData[key]) != JSON.stringify(this.apc[key])
          ) {
            detail += keys[key] + '<br/>'
          }
        })
        await operation.add({
          authorityCode: 'EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.EDIT_APC',
          type: 'EDIT',
          info: `Edit The APC Information: ${this.articleDetail.code}`,
          detail
        })
        this.$message.success({
          title: 'Success',
          content: 'APC updated Successfully!'
        })
        this.getQuery()
        this.getAPC(this.id)
        this.isEditApc = false
      }
    },

    async getAPC(id) {
      const res = await apc.query(id)
      if (res) {
        this.apc = JSON.parse(JSON.stringify(res))
        this.apcData = JSON.parse(JSON.stringify(res))
        // this.apc = res
      } else {
        this.apc = {
          price: '',
          discount: '',
          discountFee: this.articleDetail.discount,
          total: '',
          satisfied: false,
          manuscriptId: id
        }
      }
    },

    getAPCRules() {
      this.apcRules = {
        price: [
          {
            required: true,
            message: 'Journal APC' + this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 0,
            message: 'Must be greater than 0'
          }
        ],
        discount: [
          {
            // required: true,
            message: 'Discount' + this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 0,
            max: 100,
            message: 'Please enter 0-100'
          }
        ],
        discountFee: [
          {
            // required: true,
            message: 'Journal APC' + this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 0,
            message: 'Must be greater than 0'
          }
        ],
        total: [
          {
            required: true,
            message: 'Total' + this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 0,
            message: 'Must be greater than 0'
          }
        ]
      }
    },

    getDecison() {
      this.decisionList = []
      for (let key in DECISION) {
        this.decisionList.push({
          name: DECISION[key],
          value: key
        })
      }
    },
    Decision(statu) {
      this.inputData = {
        id: this.articleDetail.id,
        sign: this.articleDetail.sign,
        statu: statu
      }
      this.showReviewReport = true
    },
    async decisionConfirm(statu) {
      let link = ''
      this.showReviewReport = false
      if (!this.macademic[statu]) {
        location.href = `/editorial-office/manuscripts/author-revision?sign=${this.articleDetail.sign}&manuscriptId=${this.articleDetail.id}`
        return
      }
      link = `/editorial-office/manuscripts/decision-external/${statu}/${this.macademic[statu].macademicId}?manuscriptId=${this.articleDetail.id}&sign=${this.articleDetail.sign}`
      this.$router.push(link)
    },

    finalDecision() {
      this.$router.push(
        `/editorial-office/manuscripts/decisions-final?sign=${this.articleDetail.sign}&manuscriptId=${this.articleDetail.id}`
      )
    },

    async submitDecision() {
      if (this.othersReason && this.othersReason.length > 2048) {
        this.$message.error({
          title: 'Error',
          content: `The length of reason is too long and must be less than 2048 bytes.`
        })
        return
      }
      if (
        ['PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(
          this.decision.decisionStatus
        ) &&
        moment(this.decision.reviseDueTime).isBefore(moment())
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Must be greater than current time'
        })
        return
      }
      if (
        ['PENDING_MINOR_REVISIONS', 'PENDING_MAJOR_REVISIONS'].includes(
          this.decision.decisionStatus
        ) &&
        !this.decision.reviseDueTime
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please select a Revision Due Date!'
        })
        return
      }
      if (
        ['REJECTED'].includes(this.decision.decisionStatus) &&
        !this.selectReason
      ) {
        this.$message.error({
          title: 'Error',
          content: `Reject Reason can't be empty!`
        })
        return
      }

      if (
        this.decision.decisionStatus === 'REJECTED' &&
        this.selectReason &&
        !this.othersReason.trim()
      ) {
        const flag = this.othersId.find(id => {
          return id === this.selectReason
        })
        if (flag) {
          this.$message.error({
            title: 'Error',
            content: `Reject Reason can't be empty!`
          })
          return false
        }
      }
      const codes = {
        PAPER_ACCEPTED: 'ACCEPT_MANUSCRIPT',
        PENDING_MINOR_REVISIONS: 'MINOR_REVISION_FOR_MANUSCRIPT',
        PENDING_MAJOR_REVISIONS: 'MAJOR_REVISION_FOR_MANUSCRIPT',
        REJECTED: 'REJECT_MANUSCRIPT',
        WITHDRAWN: 'WITHDRAW'
      }
      let event = codes[this.decision.decisionStatus]
      // console.log(this.decision, codes[this.decision.decisionStatus])
      this.sendEmail(this.articleDetail, event, 'submit_to_author')
      // await editorDecision.author({
      //   id: this.articleDetail.id,
      //   sign: this.articleDetail.sign,
      //   meditor: this.decision
      // })

      // this.getQuery()
      // this.$message.success({
      //   title: 'Success',
      //   content: 'Make decision successfully'
      // })
    },

    async getMacademic(type) {
      if (type) {
        this.macademic[type] = await macademic.manuscript(
          this.articleDetail.id,
          type,
          this.articleDetail.sign
        )
      } else {
        this.macademic.PRE_CHECK = await macademic.manuscript(
          this.articleDetail.id,
          'PRE_CHECK',
          this.articleDetail.sign
        )
        this.macademic.FIRST_CHECK = await macademic.manuscript(
          this.articleDetail.id,
          'FIRST_CHECK',
          this.articleDetail.sign
        )
        this.macademic.FINAL_CHECK = await macademic.manuscript(
          this.articleDetail.id,
          'FINAL_CHECK',
          this.articleDetail.sign
        )
      }
      this.PRE_remind = this.formatRemindTime(
        this.macademic.PRE_CHECK.remindTimeList
          ? this.macademic.PRE_CHECK.remindTimeList
          : []
      )
      this.FIRST_remind = this.macademic.FIRST_CHECK.remindTimeList
        ? this.macademic.FIRST_CHECK.remindTimeList
        : []
      this.FINAL_remind = this.macademic.FINAL_CHECK.remindTimeList
        ? this.macademic.FINAL_CHECK.remindTimeList
        : []
    },

    formatRemindTime(arr) {
      if (arr && arr.length) {
        arr = arr.map(item => {
          item = this.$moment(item).format('DD MMMM YYYY')
          return item
        })
      } else {
        return
      }
      return Array.from(new Set(arr))
    },

    async endDecision(type, started) {
      if (
        this.macademic[type].invitedTime &&
        !this.macademic[type].person.decisionStatus
      ) {
        this.$message.error({
          title: 'Error',
          content:
            'The  Academic Editor is making decision. Please cancel Invitation before ending the process!'
        })
        return
      }
      let types = ''
      if (!started || type === 'FINAL_CHECK') {
        this.endConfirm = true
        if (type === 'PRE_CHECK') {
          types = 'Pre-check'
        } else if (type === 'FIRST_CHECK') {
          types = 'First decision'
        } else if (type === 'FINAL_CHECK') {
          types = 'Final decision'
        }
        this.inputData = {
          sign: this.articleDetail.sign,
          id: this.articleDetail.id,
          started,
          type,
          types
        }
        return
      }
      await macademic.started(this.articleDetail.id, type, {
        sign: this.articleDetail.sign,
        started
      })
      this.getQuery()
    },

    async invite(val, type, emailType) {
      let emailTypes = emailType
      if (
        !this.macademic[type].macademicFileList ||
        !this.macademic[type].macademicFileList.length
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please upload the review document first！'
        })
        return
      }

      if (type != 'PRE_CHECK' && this.articleDetail.sign > 1) {
        // const data = await macademic.manuscript(
        //   this.articleDetail.id,
        //   statu,
        //   this.articleDetail.sign - 1
        // )
        const dataFirst = await macademic.manuscript(
          this.articleDetail.id,
          'FIRST_CHECK',
          this.articleDetail.sign - 1
        )
        const dataFinal = await macademic.manuscript(
          this.articleDetail.id,
          'FINAL_CHECK',
          this.articleDetail.sign - 1
        )
        if (
          (dataFirst.macademicHistoryList &&
            dataFirst.macademicHistoryList[0] &&
            dataFirst.macademicHistoryList[0].authorReply &&
            !dataFirst.macademicHistoryList[0].editorUpdated) ||
          (dataFinal.macademicHistoryList &&
            dataFinal.macademicHistoryList[0] &&
            dataFinal.macademicHistoryList[0].authorReply &&
            !dataFinal.macademicHistoryList[0].editorUpdated)
        ) {
          this.$confirm({
            title: 'Author Response Edit Reminder',
            content:
              'The previous version had author response that is not processed, please process it first.',
            type: 'warning',
            icon: 'iconReminder',
            confirmText: 'Go to Processing'
          }).then(async () => {
            this.changeVersion(this.articleDetail.sign - 1)
          })
          return
        }
      }

      this.$confirm({
        title: 'Invite Academic Editor',
        content: 'Are you sure you want to proceed?',
        type: 'danger',
        icon: 'iconDetails'
      }).then(async () => {
        const data = await macademic.invite(this.articleDetail.id, type, {
          personId: this.macademic[type].person.id,
          sign: this.articleDetail.sign
        })
        this.showEmailSendData = data
        this.getQuery()
        if (data.geed) {
          emailTypes =
            emailType === 'INVITE_PRE_CHECK'
              ? 'GE_INVITE_PRE_CHECK'
              : emailType === 'INVITE_FIRST_CHECK'
              ? 'GE_INVITE_FIRST_DECISION'
              : 'GE_INVITE_FINAL_DECISION'
        }
        this.sendEmail(val, emailTypes, emailTypes)
      })
    },

    checkDecision(type) {
      if (type === 'PRE_CHECK') {
        let link = ''
        link = `/editorial-office/manuscripts/decision-external/${type}/${this.macademic[type].macademicId}?manuscriptId=${this.articleDetail.id}&sign=${this.articleDetail.sign}`
        this.$router.push(link)
        return
      }
      this.Decision(type)
    },

    Remind(val, type) {
      this.sendEmail(val, type)
    },

    async cancelInvitation(type) {
      await macademic.cancelInvite(this.articleDetail.id, type, {
        sign: this.articleDetail.sign
      })
      this.getMacademic(type)
    },

    chooseAnotherEditor(val, type) {
      if (
        !this.macademic[type].macademicFileList ||
        !this.macademic[type].macademicFileList.length
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please upload the review document first！'
        })
        return
      }
      if (
        this.macademic[type].invitedTime &&
        !this.macademic[type].person.decisionStatus
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please cancel the current invitation first.'
        })
        return
      }
      this.showSelectEditor = true
      this.decisionType = type
      this.inputData = val || {}
      this.macademic[type].invitedTime = ''
    },

    changeDecisionEditor(val, type) {
      this.showSelectEditor = false
      this.macademic[type].person = val
    },

    async peerView() {
      await meditor.resubmission(this.articleDetail.id)
      this.getQuery()
    },
    showDecision(item, type) {
      let link = `/academic-menu/academic/detail/${type}/${item.id}?manuscriptId=${this.articleDetail.id}&sign=${item.sign}&status=${item.status}`
      // this.$router.push(link)
      help.openWindow(link)
    },
    sendAE(item, type) {
      this.editAEC[type] = true
      this.showAEC[type] = true
      const { id, authorReply, authorReplyFileList } = item
      this.authorReply = {
        macademicId: id,
        authorReply,
        authorReplyFileList: authorReplyFileList || [],
        loading: false
      }
    },
    async confirmAE(type) {
      this.$confirm({
        title: 'Visible for Academic Editor',
        content:
          "After confirmation, the Academic Editor can see the author's reply",
        type: 'danger',
        icon: 'iconDetails'
      }).then(async () => {
        const data = Object.assign(
          {
            manuscriptId: this.articleDetail.id,
            sign: this.articleDetail.sign
          },
          this.authorReply
        )
        await macademic.authorReply(data)

        this.$message.success({
          title: 'Success',
          content: 'Author Response was sent successfully!'
        })
        this.getMacademic(type)
        this.cancelAE(type)
      })
    },
    cancelAE(type) {
      this.editAEC[type] = false
      this.authorReply = {
        macademicId: '',
        authorReply: '',
        authorReplyFileList: [],
        loading: false
      }
    },
    delAECDoc(index) {
      this.authorReply.authorReplyFileList.splice(index, 1)
    },

    transfer() {
      this.inputData = this.articleDetail
      this.showTransfer = true
    },

    downloadMfile(url, name, val) {
      this.$set(val, 'loading', true)
      this.download(url, name, progress => {
        this.$set(val, 'progress', progress)
        if (progress === 100) {
          this.$set(val, 'loading', false)
          setTimeout(() => {
            this.$set(val, 'progress', 0)
          }, 2000)
        }
      })
    },

    openLink(record, type) {
      let link = ''
      if (type === 'person') {
        link = `/user-manage/manage-users/${record.personId}/personal-information`
      } else {
        link = record.hindexUrl
          ? record.hindexUrl
          : `https://www.scopus.com/results/authorNamesList.uri?s=AUTHLASTNAME%28${record.lastName}%29+AND+AUTHFIRST%28${record.firstName}%29&st1=${record.lastName}&st2=${record.firstName}`
      }
      help.openWindow(link)
    },
    // 检查note
    handleCheckNote() {
      this.inputData = this.articleDetail
      this.showCheck = true
    },

    // 检查radio
    async handleCheckRadio() {
      this.articleDetail.checked = !this.articleDetail.checked
      await editorManuscript.check(this.articleDetail.id, {
        checked: this.articleDetail.checked,
        sign: this.articleDetail.sign,
        version: this.articleDetail.version
      })
      this.$message.success({
        title: 'Success',
        content: `This Checked has been saved!`
      })
    },
    async handleSuggest(id, num, version, index) {
      if (num === this.articleReviewer[index].suggestReferNum) {
        return
      } else if (num < 0 || num > 99 || !Number.isInteger(num)) {
        this.$message.error({
          title: 'Error',
          content: `This Suggest Own References is invalid`
        })
      } else {
        if (!num) {
          num = 0
        }
        const params = {
          suggestReferNum: num,
          version: version
        }
        await minvitedReviewer.suggest(id, params)
        this.$message.success({
          title: 'Success',
          content: `This Suggest Own References has been saved!`
        })
        this.getArticleReviewer(this.pagination.current)
      }
    },
    limitInputValue(e) {
      let key = e.key
      if (key === 'e' || key === 'E') {
        e.returnValue = false
        return false
      }
      return true
    },
    //拒绝理由列表
    async getRefuseList() {
      const params = {
        publisherId: this.publisherId,
        personId: ''
      }
      this.refuseList = await editor.refuse(params)
      this.initSetCheck()

      this.getOthersIds(this.refuseList)
    },

    // 处理Others
    getOthersIds(list) {
      const ids = []
      list &&
        list.map(item => {
          if (item.children) {
            item.children.map(child => {
              if (child.name === 'Others') {
                ids.push(child.id)
              }
            })
          }
        })
      this.othersId = ids
    },
    // 添加check属性
    initSetCheck() {
      this.refuseList.map(item => {
        if (item.children) {
          item.children.map(child => {
            Object.assign(child, {
              check: false
            })
          })
        }
      })
    },
    checkItem(index) {
      //展开或折叠面板
      this.othersReason = ''
      this.refuseList.map((item, root) => {
        if (item.children) {
          item.children.map((child, leaf) => {
            this.$set(child, 'check', false) // others
            this.$forceUpdate()
            this.$set(child, 'checked', false) // 节点选中
            this.$forceUpdate()
            this.$set(this.isOpenItem[root], 'group', false)
            this.$forceUpdate()
          })
        }
      })
      this.$set(this.isOpenItem[index], 'group', !this.isOpenItem[index].group)
    },

    stateChanged(item, index, i) {
      this.othersReason = ''
      this.selectReason = item.id
      if (item.name === 'Others') {
        this.refuseList.map(node => {
          if (node.children) {
            node.children.map(child => {
              this.$set(child, 'check', false)
              this.$forceUpdate()
            })
          }
        })
        this.$set(item, 'check', true)
        this.$forceUpdate()
      } else {
        this.refuseList.map(node => {
          if (node.children) {
            node.children.map(child => {
              this.$set(child, 'check', false)
              this.$forceUpdate()
            })
          }
        })
      }

      this.refuseList.map((item, root) => {
        this.$set(item, 'checked', false)
        if (item.children) {
          item.children.map((child, leaf) => {
            if (child.id == this.selectReason) {
              this.$set(child, 'checked', true)
              this.$forceUpdate()
              this.$set(item, 'checked', true)
              this.$forceUpdate()
              this.$set(this.isOpenItem[root], 'group', true)
              this.$forceUpdate()
              this.$set(this.isSelectAll[leaf], 'group', true)
              this.$forceUpdate()
            }
          })
        }
      })
    },

    initData() {
      //数据初始化
      let len = this.refuseList.length
      for (let i = 0; i < len; i++) {
        //根据数据初始化全选按钮状态
        this.isSelectAll.push([])
        // Object.assign(this.isSelectAll[i], { group: false })
        this.$set(this.isSelectAll[i], 'group', false)
        this.$set(this.isSelectAll[i], 'child', [])
        //根据数据初始化折叠面板折叠状态
        this.isOpenItem.push([])
        this.$set(this.isOpenItem[i], 'group', false)
        this.$set(this.isOpenItem[i], 'child', [])
        //设置第二层级的状态
        for (let j in this.refuseList[i].children) {
          this.isSelectAll[i].child.push(false)
          this.isOpenItem[i].child.push(false)
        }
      }
    }
  }
}
